import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-896047c2")

_pushScopeId("data-v-896047c2")
const _hoisted_1 = { class: "performanceOverview" }
const _hoisted_2 = { class: "corePerformance11" }
const _hoisted_3 = { style: {"display":"flex","align-items":"center","margin-bottom":"0.5rem"} }
const _hoisted_4 = /*#__PURE__*/_createVNode("h5", {
  class: "TitleStyle",
  style: {"margin-bottom":"0px"}
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存趋势 ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "corePerformance11" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("测试记录")
], -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("(")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "corePerformance11" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h5", {
  class: "TitleStyle",
  id: "memoryScrol"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存详情 ")
], -1)
const _hoisted_13 = { class: "memory_flex" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { style: {"font-size":"16px","margin-right":"50px"} }, " 当前数据 ", -1)
const _hoisted_15 = { class: "memory_flex" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { style: {"font-size":"16px","margin-right":"50px"} }, " 对比数据 ", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("对比")
const _hoisted_18 = { style: {"display":"flex"} }
const _hoisted_19 = { style: 'width:' + '35%' }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { style: {"font-size":"16px"} }, "模块内存分布", -1)
const _hoisted_21 = {
  key: 0,
  style: {"height":"100%"}
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { style: {"width":"65%"} }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { style: {"font-size":"16px","margin-bottom":"53px"} }, " 模块内存差异 ", -1)
const _hoisted_25 = {
  key: 0,
  class: "uObject",
  style: {"margin-bottom":"12px"}
}
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" UObject ")
const _hoisted_28 = /*#__PURE__*/_createVNode("div", {
  id: "objectSize",
  style: {"height":"350px","width":"100%"}
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", {
  id: "objectCount",
  style: {"height":"350px","width":"100%"}
}, null, -1)
const _hoisted_30 = { class: "corePerformance11" }
const _hoisted_31 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("对象内存详情")
], -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("数据下载")
const _hoisted_34 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 2,
  style: {"width":"300px"}
}
const _hoisted_37 = { class: "btn_color" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_42 = { key: 3 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 4 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_47 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_h8 = _resolveComponent("h8")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_tabs, {
                  onTabClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.tabsChange(_ctx.activeName))),
                  type: "card",
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.activeName = $event))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.localProject == 34
                ? _ctx.tabsData.filter((v, index) => index == 1)
                : _ctx.tabsData, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_tab_pane, {
                        key: index,
                        name: index,
                        label: item.name,
                        disabled: _ctx.tabsdis
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_card, null, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_2, [
                                _createVNode("div", _hoisted_3, [
                                  _hoisted_4,
                                  _createVNode(_component_h8, { style: {"margin-left":"10px"} }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_tooltip, {
                                        effect: "dark",
                                        content: "近三个月内存趋势",
                                        placement: "top"
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_5
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createVNode(_component_el_form, {
                                  class: "spacForm",
                                  size: "mini",
                                  inline: true
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, { label: "机型" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: item.form.device,
                                          "onUpdate:modelValue": ($event: any) => (item.form.device = $event),
                                          onChange: ($event: any) => (_ctx.trendChange('device', item.form, index)),
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.device_id,
                                                label: item.device_id__model__name,
                                                value: item.device_id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_form_item, {
                                      class: "sceneWidth",
                                      label: "场景"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: item.form.scene,
                                          "onUpdate:modelValue": ($event: any) => (item.form.scene = $event),
                                          onChange: ($event: any) => (_ctx.trendChange('scene', item.form, index)),
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneOptions, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.scene_id,
                                                label: item.scene_id__chinese,
                                                value: item.scene_id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_form_item, { label: "时间选择" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_date_picker, {
                                          onChange: ($event: any) => (_ctx.pickChange(item.form, index)),
                                          modelValue: item.form.pick,
                                          "onUpdate:modelValue": ($event: any) => (item.form.pick = $event),
                                          type: "daterange",
                                          "range-separator": "To",
                                          "start-placeholder": "开始日期",
                                          "end-placeholder": "结束日期"
                                        }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                (_ctx.echartShow)
                                  ? (_openBlock(), _createBlock("div", {
                                      key: 0,
                                      id: 'memory' + String(index),
                                      style: {"width":"100%","height":"350px"}
                                    }, null, 8, ["id"]))
                                  : (_openBlock(), _createBlock("div", _hoisted_6, [
                                      _createVNode(_component_el_empty, { description: "无数据" })
                                    ]))
                              ]),
                              _createVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createVNode(_component_el_form, {
                                  class: "spacForm",
                                  size: "mini",
                                  inline: true
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, { label: "时间" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          filterable: "",
                                          onChange: ($event: any) => (_ctx.testChange(item.form, index)),
                                          modelValue: item.form.date,
                                          "onUpdate:modelValue": ($event: any) => (item.form.date = $event),
                                          multiple: "",
                                          "collapse-tags": "",
                                          "collapse-tags-tooltip": "",
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: item,
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_form_item, { label: "机型" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          onChange: ($event: any) => (_ctx.testChange(item.form, index)),
                                          modelValue: item.form.testDevice,
                                          "onUpdate:modelValue": ($event: any) => (item.form.testDevice = $event),
                                          multiple: "",
                                          "collapse-tags": "",
                                          "collapse-tags-tooltip": "",
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.device_id,
                                                label: item.device_id__model__name,
                                                value: item.device_id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_form_item, {
                                      class: "sceneWidth",
                                      label: "场景"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          onChange: ($event: any) => (_ctx.testChange(item.form, index)),
                                          modelValue: item.form.testScene,
                                          "onUpdate:modelValue": ($event: any) => (item.form.testScene = $event),
                                          multiple: "",
                                          "collapse-tags": "",
                                          "collapse-tags-tooltip": "",
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneOptions, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.scene_id,
                                                label: item.scene_id__chinese,
                                                value: item.scene_id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (_ctx.activeName != 0 || _ctx.localProject == 34)
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 0,
                                          label: "子场景"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: item.form.subScene,
                                              "onUpdate:modelValue": ($event: any) => (item.form.subScene = $event),
                                              onChange: ($event: any) => (_ctx.testChange(item.form, index)),
                                              multiple: "",
                                              "collapse-tags": "",
                                              "collapse-tags-tooltip": "",
                                              placeholder: "请选择"
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subscneOptions, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item.scene,
                                                    label: item.scene,
                                                    value: item.scene
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                (_ctx.tableShow)
                                  ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                                      key: 0,
                                      "header-cell-style": {
                      background: '#f5f7fa',
                    },
                                      border: "",
                                      data: _ctx.recondList.list,
                                      style: {"width":"100%"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_table_column, {
                                          prop: "date_version",
                                          label: "日期版本",
                                          width: "280"
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          prop: "date_version",
                                          label: "对比日期版本",
                                          width: "280"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.old_params.date_version), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          prop: "device",
                                          label: "机型",
                                          width: "180"
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          prop: "scene",
                                          label: "场景",
                                          width: "250"
                                        }),
                                        (item.name != 'memreport')
                                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                                              key: 0,
                                              label: "子场景",
                                              width: "150"
                                            }, {
                                              default: _withId((scope) => [
                                                _createVNode("span", null, _toDisplayString(scope.row.sub_scene), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_el_table_column, {
                                          label: 
                        item.name === 'memreport' ? 'physical_memory' : '内存'
                      ,
                                          width: "150"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row.size.toFixed(2) + "M"), 1),
                                            (scope.row.change !== '')
                                              ? (_openBlock(), _createBlock("span", {
                                                  key: 0,
                                                  style: 'color:' + _ctx.com_num_color(scope.row.change)
                                                }, [
                                                  _hoisted_9,
                                                  _createVNode("span", null, _toDisplayString(String(scope.row.change).indexOf("-") != -1 ||
                            scope.row.change == 0
                              ? ""
                              : "+"), 1),
                                                  _createTextVNode(_toDisplayString(scope.row.change + "M" + ")"), 1)
                                                ], 4))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1032, ["label"]),
                                        _createVNode(_component_el_table_column, {
                                          label: "操作",
                                          width: "80"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", {
                                              style: {"cursor":"pointer","color":"#409eff"},
                                              onClick: ($event: any) => (_ctx.look(item.form, scope.row, index))
                                            }, "查看", 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (index == 0)
                                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                                              key: 1,
                                              align: "center",
                                              label: "下载memreport",
                                              width: "150"
                                            }, {
                                              default: _withId((scope) => [
                                                (scope.row.file_path)
                                                  ? (_openBlock(), _createBlock("a", {
                                                      key: 0,
                                                      style: {"text-decoration":"none","cursor":"pointer","color":"#409eff"},
                                                      download: "",
                                                      href: scope.row.file_path
                                                    }, "下载", 8, ["href"]))
                                                  : (_openBlock(), _createBlock("span", _hoisted_10, "下载"))
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["data"])), [
                                      [_directive_loading, _ctx.testLoading]
                                    ])
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_pagination, {
                                  style: {"text-align":"right"},
                                  currentPage: _ctx.currentPage,
                                  "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentPage = $event)),
                                  "page-size": "10",
                                  total: _ctx.recondList.count,
                                  layout: "total, prev, pager, next,jumper",
                                  onCurrentChange: ($event: any) => (_ctx.handleCurrentChange(item.form, index))
                                }, null, 8, ["currentPage", "total", "onCurrentChange"])
                              ]),
                              _createVNode("div", _hoisted_11, [
                                _hoisted_12,
                                _createVNode("div", _hoisted_13, [
                                  _hoisted_14,
                                  _createVNode(_component_el_form, {
                                    style: {"display":"flex"},
                                    size: "mini",
                                    inline: true
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_form_item, {
                                        class: "dateWidth",
                                        label: "时间版本"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            onChange: ($event: any) => (_ctx.b(item)),
                                            modelValue: item.form.memoryDate,
                                            "onUpdate:modelValue": ($event: any) => (item.form.memoryDate = $event),
                                            placeholder: "请选择"
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item,
                                                  label: item,
                                                  value: item
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_form_item, { label: "机型" }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: item.form.memoryDevice,
                                            "onUpdate:modelValue": ($event: any) => (item.form.memoryDevice = $event),
                                            placeholder: "请选择"
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.device_id,
                                                  label: item.device_id__model__name,
                                                  value: item.device_id
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_form_item, {
                                        class: "sceneWidth",
                                        label: "场景"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: item.form.memoryScene,
                                            "onUpdate:modelValue": ($event: any) => (item.form.memoryScene = $event),
                                            placeholder: "请选择"
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneOptions, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.scene_id,
                                                  label: item.scene_id__chinese,
                                                  value: item.scene_id
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (item.name != 'memreport')
                                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                                            key: 0,
                                            label: "子场景"
                                          }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_select, {
                                                modelValue: item.form.memorySubscene,
                                                "onUpdate:modelValue": ($event: any) => (item.form.memorySubscene = $event),
                                                placeholder: "请选择"
                                              }, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subscneOptions, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: item.scene,
                                                      label: item.scene,
                                                      value: item.scene
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createVNode("div", _hoisted_15, [
                                  _hoisted_16,
                                  _createVNode(_component_el_form, {
                                    style: {"display":"flex"},
                                    size: "mini",
                                    inline: true
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_form_item, {
                                        class: "dateWidth",
                                        label: "时间版本"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: item.form.memoryOldDate,
                                            "onUpdate:modelValue": ($event: any) => (item.form.memoryOldDate = $event),
                                            placeholder: "请选择"
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item,
                                                  label: item,
                                                  value: item
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_form_item, { label: "机型" }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: item.form.memoryOldDevice,
                                            "onUpdate:modelValue": ($event: any) => (item.form.memoryOldDevice = $event),
                                            placeholder: "请选择"
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.device_id,
                                                  label: item.device_id__model__name,
                                                  value: item.device_id
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_form_item, {
                                        class: "sceneWidth",
                                        label: "场景"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: item.form.memoryOldScene,
                                            "onUpdate:modelValue": ($event: any) => (item.form.memoryOldScene = $event),
                                            placeholder: "请选择"
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneOptions, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.scene_id,
                                                  label: item.scene_id__chinese,
                                                  value: item.scene_id
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (item.name != 'memreport')
                                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                                            key: 0,
                                            label: "子场景"
                                          }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_select, {
                                                modelValue: item.form.memoryOldSubscene,
                                                "onUpdate:modelValue": ($event: any) => (item.form.memoryOldSubscene = $event),
                                                placeholder: "请选择"
                                              }, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subscneOptions, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: item.scene,
                                                      label: item.scene,
                                                      value: item.scene
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createVNode("div", null, [
                                  _createVNode(_component_el_button, {
                                    onClick: ($event: any) => (_ctx.contrast(item.form, index)),
                                    style: {"height":"28px"},
                                    size: "small",
                                    type: "primary"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_17
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _createVNode("div", _hoisted_18, [
                                  _createVNode("div", _hoisted_19, [
                                    _hoisted_20,
                                    (_ctx.cilList.length > 0)
                                      ? (_openBlock(), _createBlock("div", _hoisted_21, [
                                          _createVNode("div", {
                                            id: 'modular' + String(index),
                                            style: {"width":"100%","height":"525px"}
                                          }, null, 8, ["id"])
                                        ]))
                                      : (_openBlock(), _createBlock("div", _hoisted_22, [
                                          _createVNode(_component_el_empty, { description: "无数据" })
                                        ]))
                                  ]),
                                  _createVNode("div", _hoisted_23, [
                                    _hoisted_24,
                                    _createVNode("div", null, [
                                      _withDirectives(_createVNode(_component_el_table, {
                                        size: "mini",
                                        style: {"width":"100%"},
                                        "cell-style": _ctx.cellStyle,
                                        "header-cell-style": {
                            background: '#f5f7fa',
                          },
                                        border: "",
                                        data: _ctx.cilList
                                      }, {
                                        default: _withId(() => [
                                          (_ctx.localProject == 34)
                                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                                key: 0,
                                                prop: "classification",
                                                label: "分类"
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_el_table_column, {
                                            prop: "name",
                                            label: "模块"
                                          }),
                                          _createVNode(_component_el_table_column, {
                                            prop: "value",
                                            label: "内存"
                                          }, {
                                            default: _withId((scope) => [
                                              _createTextVNode(_toDisplayString(scope.row.value + "M"), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_table_column, {
                                            prop: "value",
                                            label: "占比"
                                          }, {
                                            default: _withId((scope) => [
                                              _createTextVNode(_toDisplayString(scope.row.rate.toFixed(2) + "%"), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_table_column, {
                                            prop: "value",
                                            label: "变化"
                                          }, {
                                            default: _withId((scope) => [
                                              _createVNode("span", {
                                                style: 
                                  'color:' + _ctx.com_num_color(scope.row.change)
                                
                                              }, [
                                                _createVNode("span", null, _toDisplayString(String(scope.row.change).indexOf("-") != -1 ||
                                  scope.row.change == 0
                                    ? ""
                                    : "+"), 1),
                                                _createTextVNode(_toDisplayString(scope.row.change + "M"), 1)
                                              ], 4)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["cell-style", "data"]), [
                                        [_directive_loading, _ctx.memoryLoading]
                                      ])
                                    ])
                                  ])
                                ]),
                                (_ctx.localProject == 12 && index == 0)
                                  ? (_openBlock(), _createBlock("div", _hoisted_25, [
                                      _createVNode(_component_h8, { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, {
                                        default: _withId(() => [
                                          _hoisted_26,
                                          _hoisted_27
                                        ]),
                                        _: 1
                                      }),
                                      _withDirectives(_createVNode(_component_el_table, {
                                        "header-cell-style": {
                        background: '#f5f7fa',
                      },
                                        border: "",
                                        data: _ctx.uobjectData
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_table_column, {
                                            label: "Module",
                                            prop: "Module"
                                          }),
                                          _createVNode(_component_el_table_column, {
                                            label: "SubModule",
                                            prop: "SubModule"
                                          }),
                                          _createVNode(_component_el_table_column, {
                                            label: "UObjectCount",
                                            prop: "UObjectCount"
                                          }),
                                          _createVNode(_component_el_table_column, {
                                            label: "变化",
                                            prop: "UObjectCount变化"
                                          }, {
                                            default: _withId((scope) => [
                                              _createVNode("span", {
                                                style: 
                              'color:' + _ctx.text(scope.row['UObjectCount变化'])[1]
                            
                                              }, _toDisplayString(_ctx.text(scope.row["UObjectCount变化"])[0]), 5)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_table_column, {
                                            label: "UObjectSize(MB)",
                                            prop: "UObjectSize"
                                          }),
                                          _createVNode(_component_el_table_column, {
                                            label: "变化(KB)",
                                            prop: "UObjectSize变化"
                                          }, {
                                            default: _withId((scope) => [
                                              _createVNode("span", {
                                                style: 
                              'color:' + _ctx.text(scope.row['UObjectSize变化'])[1]
                            
                                              }, _toDisplayString(_ctx.text(scope.row["UObjectSize变化"])[0]), 5)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["data"]), [
                                        [_directive_loading, _ctx.uObjectLoading]
                                      ]),
                                      _createVNode(_component_el_tabs, {
                                        type: "card",
                                        class: "demo-tabs spacName",
                                        modelValue: _ctx.objectName,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.objectName = $event)),
                                        style: {"width":"100%"},
                                        onTabClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleClick_object()))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_tab_pane, {
                                            label: "size",
                                            name: "first",
                                            style: {"padding":"10px"}
                                          }, {
                                            default: _withId(() => [
                                              _withDirectives(_createVNode(_component_el_card, null, {
                                                default: _withId(() => [
                                                  _hoisted_28
                                                ]),
                                                _: 1
                                              }, 512), [
                                                [_directive_loading, _ctx.uObjectTrendLoading]
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_tab_pane, {
                                            label: "count",
                                            name: "Second",
                                            style: {"padding":"10px"}
                                          }, {
                                            default: _withId(() => [
                                              _withDirectives(_createVNode(_component_el_card, null, {
                                                default: _withId(() => [
                                                  _hoisted_29
                                                ]),
                                                _: 1
                                              }, 512), [
                                                [_directive_loading, _ctx.uObjectTrendLoading]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode("div", _hoisted_30, [
                                _hoisted_31,
                                (_ctx.merShow)
                                  ? (_openBlock(), _createBlock("div", _hoisted_32, [
                                      _createVNode(_component_el_form, {
                                        class: "spacForm",
                                        size: "mini",
                                        inline: true,
                                        style: {"display":"flex","justify-content":"space-between"}
                                      }, {
                                        default: _withId(() => [
                                          _createVNode("div", null, [
                                            _createVNode(_component_el_form_item, { label: "类型选择" }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_select, {
                                                  onChange: ($event: any) => (_ctx.typeChange(index)),
                                                  modelValue: item.form.type,
                                                  "onUpdate:modelValue": ($event: any) => (item.form.type = $event),
                                                  placeholder: "请选择"
                                                }, {
                                                  default: _withId(() => [
                                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nameList, (item) => {
                                                      return (_openBlock(), _createBlock(_component_el_option, {
                                                        key: item,
                                                        label: item,
                                                        value: item
                                                      }, null, 8, ["label", "value"]))
                                                    }), 128))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_el_form_item, { label: "" }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_button, {
                                                  type: "primary",
                                                  onClick: _ctx.downloadCsv
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_33
                                                  ]),
                                                  _: 1
                                                }, 8, ["onClick"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createVNode("div", null, [
                                            _createVNode(_component_el_form_item, { label: "" }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_input, {
                                                  modelValue: _ctx.course_input,
                                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.course_input = $event)),
                                                  onChange: ($event: any) => (_ctx.recordSearch(index)),
                                                  placeholder: "搜索",
                                                  "prefix-icon": "el-icon-search",
                                                  size: "mini"
                                                }, null, 8, ["modelValue", "onChange"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_table, {
                                        ref: "tableList",
                                        onSortChange: _ctx.sort_change,
                                        data: _ctx.deepMemreportData?.list
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_table_column, null, {
                                            header: _withId(() => [
                                              _createVNode("span", null, _toDisplayString(item.form.type +
                            "内存——" +
                            _ctx.cilList?.filter((m) => item.form.type == m.name)[0]
                              ?.value +
                            "M"), 1),
                                              _createVNode("span", {
                                                style: 
                              'color:' +
                              _ctx.com_num_color(
                                _ctx.cilList?.filter(
                                  (m) => item.form.type == m.name
                                )[0]?.change
                              )
                            
                                              }, "(" + _toDisplayString(String(
                                _ctx.cilList?.filter(
                                  (m) => item.form.type == m.name
                                )[0]?.change
                              ).indexOf("-") != -1 ||
                              _ctx.cilList?.filter(
                                (m) => item.form.type == m.name
                              )[0]?.change == 0
                                ? ""
                                : "+") + _toDisplayString(_ctx.cilList?.filter(
                                (m) => item.form.type == m.name
                              )[0]?.change + "M") + ")", 5)
                                            ]),
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableThead(
                            index == 0 ? item.form.type : ''
                          ), (v) => {
                                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                                  width: _ctx.tableWidth(v),
                                                  sortable: "",
                                                  key: v,
                                                  label: _ctx.chineseNames(v)
                                                }, {
                                                  default: _withId((scope) => [
                                                    _createTextVNode(_toDisplayString(scope.row.new[v]) + " ", 1),
                                                    (v === 'size' || v === 'size_ondisk')
                                                      ? (_openBlock(), _createBlock("span", {
                                                          key: 0,
                                                          style: 
                                'color:' +
                                (scope.row.old != null
                                  ? _ctx.getNum(
                                      scope.row?.new[v],
                                      scope.row?.old[v]
                                    )[1]
                                  : scope.row?.new[v] == 0
                                  ? '#606266'
                                  : 'red')
                              
                                                        }, _toDisplayString(scope.row.old != null
                                  ? _ctx.getNum(
                                      scope.row?.new[v],
                                      scope.row?.old[v]
                                    )[0]
                                  : scope.row?.new[v] === 0
                                  ? "(0)"
                                  : "(+" + scope.row?.new[v] + ")"), 5))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["width", "label"]))
                                              }), 128)),
                                              (_ctx.fullNameShow(item.form.type))
                                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                                    key: 0,
                                                    label: "full_name",
                                                    width: "200",
                                                    sortable: "",
                                                    "show-overflow-tooltip": ""
                                                  }, {
                                                    default: _withId((scope) => [
                                                      _createVNode("span", null, _toDisplayString(scope.row.new.full_name), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["onSortChange", "data"]),
                                      _createVNode("div", _hoisted_34, [
                                        _createVNode(_component_el_form, {
                                          style: {"display":"flex","align-items":"center"},
                                          inline: true,
                                          size: "mini"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_form_item, {
                                              style: {"margin-bottom":"0"},
                                              label: "每页"
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_input, {
                                                  modelValue: _ctx.size,
                                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.size = $event)),
                                                  style: {"width":"55px","height":"28px"},
                                                  onChange: ($event: any) => (_ctx.onSearch(item.form, index))
                                                }, null, 8, ["modelValue", "onChange"])
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_el_form_item, {
                                              style: {"margin-bottom":"0"},
                                              label: "条记录"
                                            }),
                                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_pagination, {
                                                  style: {"text-align":"right"},
                                                  currentPage: _ctx.page,
                                                  "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => (_ctx.page = $event)),
                                                  "page-size": _ctx.size,
                                                  total: _ctx.deepMemreportData?.count,
                                                  layout: "total, prev, pager, next,jumper",
                                                  onCurrentChange: ($event: any) => (
                              _ctx.handleCurrentChange1(item.form, index)
                            )
                                                }, null, 8, ["currentPage", "page-size", "total", "onCurrentChange"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                      _ctx.tableThead(item.form.type)?.length == 0 &&
                      item.name === 'memreport'
                    )
                                  ? (_openBlock(), _createBlock("div", _hoisted_35, [
                                      _createVNode(_component_el_empty, { description: "无数据" })
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.name != 'memreport' && _ctx.localProject !== 34)
                                  ? (_openBlock(), _createBlock("div", _hoisted_36, [
                                      _createVNode(_component_el_input, {
                                        size: "mini",
                                        modelValue: item.form.inputValue,
                                        "onUpdate:modelValue": ($event: any) => (item.form.inputValue = $event),
                                        class: _ctx.inputColor,
                                        onChange: ($event: any) => (_ctx.submit(item.form, index)),
                                        placeholder: "请输入文本过滤"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "onChange"]),
                                      _createVNode("div", _hoisted_37, [
                                        _createVNode("span", {
                                          onClick: ($event: any) => (_ctx.textChange(item.form, 'all', index))
                                        }, "所有", 8, ["onClick"]),
                                        _createVNode("span", {
                                          onClick: ($event: any) => (_ctx.textChange(item.form, 'change', index))
                                        }, "变化", 8, ["onClick"]),
                                        _createVNode("span", null, [
                                          _hoisted_38,
                                          _createVNode(_component_el_tooltip, {
                                            effect: "dark",
                                            content: "待实现",
                                            placement: "top"
                                          }, {
                                            default: _withId(() => [
                                              _hoisted_39
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createVNode("span", null, [
                                          _hoisted_40,
                                          _createVNode(_component_el_tooltip, {
                                            effect: "dark",
                                            content: "待实现",
                                            placement: "top"
                                          }, {
                                            default: _withId(() => [
                                              _hoisted_41
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.name != 'memreport' && _ctx.localProject != 34)
                                  ? (_openBlock(), _createBlock("div", _hoisted_42, [
                                      _withDirectives(_createVNode(_component_el_table, {
                                        class: "scrollTable",
                                        "row-style": _ctx.tableRowClassName,
                                        size: "small",
                                        "header-cell-style": {
                        background: '#F5F6FA',
                        color: '#B5B5B5',
                        border: '0',
                        padding: '1px,0',
                        height: '10px',
                      },
                                        data: _ctx.leftAllTable,
                                        style: {"width":"100%"},
                                        "row-key": "id",
                                        "expand-row-keys": _ctx.expandRowKeys,
                                        onExpandChange: _ctx.handleExpandChange,
                                        ref: "table"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details_list, (item, index) => {
                                            return (_openBlock(), _createBlock(_component_el_table_column, {
                                              "show-overflow-tooltip": true,
                                              sortable: "fasle",
                                              key: item.label,
                                              "min-width": item.label == '名称' ? '67%' : '16.5%',
                                              index: index,
                                              label: item.label
                                            }, {
                                              default: _withId((scope) => [
                                                (item.prop != 'size')
                                                  ? (_openBlock(), _createBlock("span", {
                                                      key: 0,
                                                      id: scope.row.id
                                                    }, _toDisplayString(scope.row[item.prop]), 9, ["id"]))
                                                  : (_openBlock(), _createBlock("span", _hoisted_43, [
                                                      _createTextVNode(_toDisplayString(_ctx.sizeCompany(String(scope.row.size))), 1),
                                                      _createVNode("span", {
                                                        style: 
                                'color:' + _ctx.deviationColor(scope.row.deviation)
                              
                                                      }, _toDisplayString(_ctx.deviation(String(scope.row.deviation))), 5)
                                                    ]))
                                              ]),
                                              _: 2
                                            }, 1032, ["min-width", "index", "label"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["row-style", "data", "expand-row-keys", "onExpandChange"]), [
                                        [_directive_loading, _ctx.allTableLoading]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.localProject == 34)
                                  ? (_openBlock(), _createBlock("div", _hoisted_44, [
                                      _withDirectives(_createVNode(_component_el_table, {
                                        class: "scrollTable",
                                        "row-style": _ctx.tableRowClassName,
                                        lazy: "",
                                        size: "small",
                                        data: _ctx.deepMemreportDataCread,
                                        load: _ctx.load,
                                        "header-cell-style": {
                        background: '#F5F6FA',
                        color: '#B5B5B5',
                        border: '0',
                        padding: '1px,0',
                        height: '10px',
                      },
                                        "row-key": "id",
                                        "tree-props": {
                        children: 'children',
                        hasChildren: 'is_expand',
                      }
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details_list, (item, index) => {
                                            return (_openBlock(), _createBlock(_component_el_table_column, {
                                              "show-overflow-tooltip": true,
                                              sortable: "fasle",
                                              key: item.label,
                                              "min-width": item.label == '名称' ? '67%' : '16.5%',
                                              index: index,
                                              label: item.label
                                            }, {
                                              default: _withId((scope) => [
                                                (item.prop != 'size')
                                                  ? (_openBlock(), _createBlock("span", {
                                                      key: 0,
                                                      id: scope.row.id
                                                    }, _toDisplayString(scope.row[item.prop]), 9, ["id"]))
                                                  : (_openBlock(), _createBlock("span", _hoisted_45, [
                                                      _createTextVNode(_toDisplayString(_ctx.sizeCompany(String(scope.row.size))), 1),
                                                      _createVNode("span", {
                                                        style: 
                                'color:' + _ctx.deviationColor(scope.row.deviation1)
                              
                                                      }, _toDisplayString(_ctx.deviation(String(scope.row.deviation1))), 5)
                                                    ]))
                                              ]),
                                              _: 2
                                            }, 1032, ["min-width", "index", "label"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["row-style", "data", "load"]), [
                                        [_directive_loading, _ctx.allTableLoading]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _hoisted_46
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["name", "label", "disabled"]))
                    }), 128)),
                    (_ctx.localProject == 12)
                      ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                          key: 0,
                          name: "3",
                          label: "Memreport LLM",
                          disabled: _ctx.tabsdis
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_card, null, {
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_table, {
                                  "header-cell-style": {
                    background: '#f5f7fa',
                    color: '#303133',
                  },
                                  size: "mini",
                                  border: "",
                                  data: 
                    _ctx.memoryLltList?.slice(
                      (_ctx.memoryLltPage - 1) * _ctx.memoryLltSize,
                      _ctx.memoryLltPage * _ctx.memoryLltSize
                    )
                  ,
                                  style: {"width":"100%","margin-bottom":"20px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, { label: "日期版本" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.date + " " + scope.row.version), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "测试时间" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.newTime), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "机型" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.device), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "场景" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.scene), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "下载源文件",
                                      width: "100"
                                    }, {
                                      default: _withId((scope) => [
                                        (scope.row.url)
                                          ? (_openBlock(), _createBlock("a", {
                                              key: 0,
                                              style: {"text-decoration":"none","cursor":"pointer","color":"#409eff"},
                                              download: "",
                                              href: scope.row.url
                                            }, "下载", 8, ["href"]))
                                          : (_openBlock(), _createBlock("span", _hoisted_47, "下载"))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"]), [
                                  [_directive_loading, _ctx.llmLoading]
                                ]),
                                _createVNode(_component_el_pagination, {
                                  style: {"text-align":"right"},
                                  currentPage: _ctx.memoryLltPage,
                                  "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => (_ctx.memoryLltPage = $event)),
                                  "page-size": _ctx.memoryLltSize,
                                  total: _ctx.memoryLltList?.length,
                                  layout: "total, prev, pager, next,jumper"
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})